import TableStyles from "../../styles/TableStyles.css";
import CommonStyles from "../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...TableStyles,
  ...CommonStyles,

  additionalControls: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    background: "#363636",
    "& h2": {
      margin: "0",
      padding: "0",
      fontSize: "18px",
    },
  },
  buttonControllers: {
    marginLeft: "auto",
    paddingRight: "10px",
    "& .MuiTypography-body1": {
      fontSize: "14px",
    },
  },
  albumNotAvailable: {
    fontSize: "14px",
    position: "absolute",
    left: "0",
    right: "0",
    top: "35%",
    bottom: "50%",
    width: "500px",
    margin: "0 auto",
  },
  tableFilterDateInputWithClear: {
    marginTop: "0",
    width: "100%",
    marginBottom: "0",
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline": {
      border: "1px solid rgba(255, 255, 255, 0.23)",
      "&:hover": {
        borderColor: "#46af22",
      },
      "&:focus": {
        borderColor: "#46af22",
      },
    },
    "& .Mui-focused": {
      borderColor: "#46af22",
    },
    "& .MuiInputAdornment-root": {
      width: "auto",
      marginRight: "3px",
      "& svg": {
        width: "18px",
      },
    },
    "& input": {
      background: "#2d2d2d",
      border: "none",
      padding: "10px !important",
    },
    "& .MuiInputAdornment-positionEnd": {
      width: "auto !important",
    },
    "&:hover .MuiInputBase-formControl": {
      borderColor: "#46af22 !important",
    },
    "&.Mui-focused .MuiInputBase-formControl": {
      borderColor: "#46af22 !important",
    },
    "& .MuiInputBase-formControl": {
      background: "#2d2d2d",
    },
  },
  bulkEditInput: {
    width: "100%",
    padding: "0",
    background: "#303030",
    "& input": {
      borderRadius: "5px !important",
      padding: "10px",
      fontSize: "0.8em",
      background: "#303030",
      margin:"0"
    },
    "& > div": {
      borderRadius: "5px",
      width: "100% !important",
      overflowY: "auto",
      height: " calc(100% - 110px)",
      position: "absolute",
    },
    "& div.MuiAutocomplete-endAdornment": {
      width: "auto !important",
    },
    "& div.MuiCircularProgress-indeterminate": {
      width: "20px !important",
      height: "20px !important",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
    "&  .MuiAutocomplete-inputRoot": {
      padding: " 2px 9px",
    },
  },
    bulkTagEditInput: {
    width: "100%",
    padding: "0",
    background: "#303030",
    "& > div": {
      borderRadius: "5px",
      width: "100% !important",
      overflowY: "auto",
      height: " calc(100% - 110px)",
      position: "absolute",
    },
  },
  tabsContainer: {
    display: "flex",
    "& .MuiTabs-indicator": {
      backgroundColor: "#0bb451",
    },
  },
  singleEdiCtontrollers: {
    display: "flex",
    alignItems: "center",
    fontSize: "13px",
    flexDirection: "row-reverse",
  },
  navigationContainer: {
    marginLeft: "5px",
    "& .MuiButton-text.Mui-disabled": {
      background: "#4E4E4E",
      fontSize: "13px",
      margin: "0 5px",
    },
    "& .MuiButton-text": {
      background: "#0C853E",
      color: "#fff",
      fontSize: "13px",
      margin: "0 5px",
    },
  },
  paginationPreviousButton: {
    background: "#0C853E",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  bulkEditLoading: {
    position: "absolute",
    height: "100%",
    width: "100%",
    left: "50%",
    right: "50%",
    top: "50%",
    width: "100%",
    textAlign: "center",
    color: "green",
    "& .MuiCircularProgress-colorPrimary": {
      color: "green",
    },
    fontSize: "70px",
  },
  globalCreateInput: {
    width: "100%",
    padding: "0",
    "& input": {
      borderRadius: "5px !important",
      padding: "12px",
      fontSize: "0.8em",
    },
    "& > div": {
      borderRadius: "5px",
      width: "100% !important",
      overflowY: "auto",
      height: " calc(100% - 0px)",
      position: "absolute",
    },
    "& div.MuiAutocomplete-endAdornment": {
      width: "auto !important",
    },
    "& div.MuiCircularProgress-indeterminate": {
      width: "20px !important",
      height: "20px !important",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
    "&  .MuiAutocomplete-inputRoot": {
      padding: " 2px 9px",
    },
  },
  bulkEditButton:{
    "& div.MuiCircularProgress-colorPrimary.MuiCircularProgress-indeterminate": {
      width: "15px !important",
      height: "15px !important",
      top: "3px",
      margin: "0 !important",
      padding: "0 !important",
    },
  },
  border_color: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#4F3F05",
    },
    "& textarea": {
      backgroundColor: "#4F3F05",
    },
  },
  commonTopButton: {
    padding: "9px",
    height: "32px",
    width: "32px",
    minWidth: "inherit",
    marginTop: "7px",
    marginLeft: "0px",
  },
  buttonCustomSize: {
    "& svg": {
      fontSize: "16px !important",
    },
  },
  infoButton: {
    color: "#D7D488",
    marginTop: "0",
  },
  addChipset: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      background: "#2d2d2d",
      padding: "8px",
    "& input":{
      background:"#2d2d2d !important",
      fontSize:"13px",
    },
    "& .MuiOutlinedInput-root": {
      background: "#2d2d2d",
      padding: "8px",
    },
    "& .MuiButtonBase-root":{
      margin: "2px !important",
    },
    "& .MuiChip-root": {
      float: "left",
      margin: "0",
      fontSize: "12px",
      height:"inherit",
     minHeight: "28px",
    padding: "4px 5px",
    },
    "& .MuiChip-deletable:focus": {
      background: "#296d12",
    },
    "& .MuiChip-label":{
      wordWrap:" break-word",
      whiteSpace: "pre-wrap !important",
      lineHeight: "15px",
      fontSize:"12px"
    }
  }
},
  checkedEmptyValue:{
   "& .MuiChip-deleteIcon":{
    display:"none",
   }
  },
  bulkUpdateGrid: {
    padding: "0",
    "& .MuiGrid-container": {
      "& > div": {
        height: "calc(100% - 1px) !important",
      },
    },
    "& .singleBlock": {
      display: "flex",
      padding: "5px 15px",
      alignItems: "center",
      "&.keywordTags .flexItem":{
        flexGrow: "2.44",
        "& .MuiAutocomplete-tag":{
          height:"auto",
        }
      },
      "& .MuiChip-clickable":{
        margin: "6px 2px 0px 2px",
      },
      "& .MuiChip-label":{
        whiteSpace: "break-spaces",
        paddingLeft: "12px",
        paddingRight: "12px",
        textOverflow: "ellipsis",
        wordBreak: "break-all",
        padding: "4px 5px",
        lineHeight: "13px !important",
      },
      "&.fullwidth": {
        display: "block",
        "& span": {
          display: "inline-block",
          verticalAlign: "middle",
          marginLeft: "5px",
        },
        "& label": {
          display: "inline-block",
          verticalAlign: " middle",
        },
      },
      "&.forty": {
        "& label": {
          flexGrow: "0.3",
        },
        "& .MuiChip-clickable":{
          margin: "6px 2px 0px 2px",
        }
      },
      "&.sixty": {
        "& label": {
          flexGrow: "0.124",
        },
        "& .MuiButtonBase-root": {
          margin: "0",
        },
        "& .MuiChip-clickable":{
          margin: "6px 2px 0px 2px",
        }
      },
      "& .Mui-disabled": {
        //opacity: "0",
      },
      "&.flexBasis .flexItem": {
        flexBasis: "68%",
      },
      "& textarea": {
        fontSize: "12px",
      },
      "& .MuiToggleButtonGroup-root": {
        "& .MuiToggleButton-root": {
          border: "none",
          padding: "0 10px 0px 5px",
          fontSize: "12px",
          color: "#fff",
          background: "none",
          "&:hover": {
            background: "none !important",
          },
          "&  .MuiSvgIcon-root":{
            marginRight:"5px"
          },
          "& .MuiTouchRipple-root": {
            background: "none !important",
          },
        },
      },
      "& > div": {
        flexGrow: "1",
        flexBasis: "0",
        minWidth: "0",
        marginTop: "0",
        marginBottom: "0",
        // paddingRight: "45px",
        position: "relative",
            display: "flex",
            padding:" 0",
        "& label": {
          margin: "0 !important",
        },
      },
      "& > label": {
        flexGrow: "0.3",
        flexBasis: "0",
        minWidth: "0",
        margin: "0",
        padding: "0",
        position: "relative",
        textTransform: "capitalize",
      },

      "& .MuiFormControl-root": {
        flexGrow: "1",
        flexBasis: "0",
        minWidth: "0",
        background: "#303030",
        borderRadius: "4px",
        "&.maxWidthInput": {
          width: "31%",
        },
        "& .MuiInput-root": {
          borderRadius: "5px",
        },
        "& .MuiFormGroup-root": {
          display: "block",
        },
      },
           "& .MuiAutocomplete-root": {
        flexGrow: "1",
        flexBasis: "0",
        minWidth: "0",
        background: "#303030",
        borderRadius: "4px",
        "&.maxWidthInput": {
          width: "31%",
        },
        "& .MuiInput-root": {
          borderRadius: "5px",
        },
        "& .MuiFormGroup-root": {
          display: "block",
        },
      },
    },
  },
  bulkTrackGrid: {
    padding: "0",
    "& .MuiGrid-container": {
      "& > div": {
        height: "calc(100% - 1px) !important",
      },
    },
    "& .singleBlock": {
       padding: "0px 0 15px 0",
      alignItems: "center",
      "& .MuiChip-clickable":{
        margin: "6px 2px 0px 2px",
      },
      "& .MuiChip-label":{
        whiteSpace: "break-spaces",
        paddingLeft: "12px",
        paddingRight: "12px",
        textOverflow: "ellipsis",
        wordBreak: "break-all",
        padding: "4px 5px",
        lineHeight: "13px !important",
      },
      "&.fullwidth": {
        display: "block",
        "& span": {
          display: "inline-block",
          verticalAlign: "middle",
          marginLeft: "5px",
        },
        "& label": {
          display: "inline-block",
          verticalAlign: " middle",
        },
      },
      "&.forty": {
        "& label": {
          flexGrow: "0.3",
        },
        "& .MuiChip-clickable":{
          margin: "6px 2px 0px 2px",
        }
      },
      "&.sixty": {
        "& label": {
          flexGrow: "0.124",
        },
        "& .MuiButtonBase-root": {
          margin: "0",
        },
        "& .MuiChip-clickable":{
          margin: "6px 2px 0px 2px",
        }
      },
 
      "&.flexBasis .flexItem": {
        flexBasis: "68%",
      },
      "& textarea": {
        fontSize: "12px",
      },
      "& .MuiToggleButtonGroup-root": {
        "& .MuiToggleButton-root": {
          border: "none",
          padding: "0 10px 0px 5px",
          fontSize: "12px",
          color: "#fff",
          background: "none",
          "&:hover": {
            background: "none !important",
          },
          "&  .MuiSvgIcon-root":{
            marginRight:"5px"
          },
          "& .MuiTouchRipple-root": {
            background: "none !important",
          },
        },
      },
      "& > div": {
        flexGrow: "1",
        flexBasis: "0",
        minWidth: "0",
        marginTop: "0",
        marginBottom: "0",
        position: "relative",
            display: "flex",
            padding:" 0",
        "& label": {
          margin: "0 !important",
        },
      },
      "& > label": {
        flexGrow: "0.3",
        flexBasis: "0",
        minWidth: "0",
        margin: "10px 0",
        padding: "0",
        position: "relative",
        textTransform: "capitalize",
      },
      "&  .MuiAutocomplete-input":{
        padding: "4px", 
        fontSize:"12px"
      },
      "& .MuiFormControl-root": {
        flexGrow: "1",
        flexBasis: "0",
        minWidth: "0",
        background: "#303030",
        borderRadius: "4px",
        "&.maxWidthInput": {
          width: "31%",
        },
        "& .MuiInput-root": {
          borderRadius: "5px",
        },
        "& .MuiFormGroup-root": {
          display: "block",
        },
      },
      "& .MuiAutocomplete-root": {
        flexGrow: "1",
        flexBasis: "0",
        minWidth: "0",
        background: "#303030",
        borderRadius: "4px",
        "&.maxWidthInput": {
          width: "31%",
        },
        "& .MuiInput-root": {
          borderRadius: "5px",
        },
        "& .MuiFormGroup-root": {
          display: "block",
        },
      },
    },
  },
  keywordTitle:{
    fontSize: "13px",
    margin: "20px 0 5px 0",
  },
  keywordSubTitle:{
    fontSize: "12px",
    margin: "8px 0 5px 0",
  },
  radioBlock:{
    clear: "left",
    display: 'block',
    margin: "10px 0",
    fontSize: "12px",
    "& .MuiFormControlLabel-label":{
          fontSize: "13px",
    }
  },
  filterItem:{
    fontSize:"12px",
    color: "#FFE600",
    textTransform:"none"
  },
 filterButton: {
    padding: "3px !important",
    minHeight: "16px !important",
    minWidth: "30px !important",
  },
  seperatText:{
  textAlign: "center",
  fontSize: "12px",
  },
  tagsDisplayTable:{
    "& .MuiTableCell-stickyHeader": {
      backgroundColor: "#2f2f2f !important",
     }
    },
  tableDataList: {
    tableLayout: "fixed",
    "& .MuiCheckbox-root": {
      padding: "0px",
    },
    "& .MuiBadge-colorSecondary": {
      backgroundColor: "#f58e00",
    },
    "& td": {
      padding: "3px 10px",
      fontSize: "0.7em",
      wordBreak: "break-word",
      cursor: "pointer",
      overflow: "hidden",
    },
    "& table td": {
      padding: "0px 10px !important",
      textAlign: "left",
      fontSize: "0.7em",
      "&.MuiTableCell-alignCenter":{
        textAlign: "center",
      }
    },
    "& td:first-child": {
      // background: "inherit",
    },
    "&  .Mui-checked svg": {
      color: "#0C853E",
    },
    "& .MuiTableRow-hover": {
     "& .MuiCircularProgress-colorPrimary":{
      color: "#fff",
    width: "20px !important",
    height: "20px !important",
     }
    },
    "& .MuiTableRow-hover:hover": {
      backgroundColor: "rgb(76 76 76 / 62%)",
      "& td": {
        backgroundColor: "rgb(76 76 76 / 62%)",
      },
    },
    "& th": {
      padding: "3px 9px",
      textAlign: "left",
      textTransform: "uppercase",
      fontWeight: "normal",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      "& label": {
        fontSize: "0.75em",
      },
      "& span":{
        "&:hover":{
          "& svg":{
            display:"block",
          }
        },
        "&.MuiTableSortLabel-active":{
          "& svg":{
            display:"block",
          }
        }
      }
    },
    "& tr.tableFocusedRow .Mui-checked svg": {
      color: "#000 !important",
    },
    "& tr.tableFocusedRow .MuiSelect-selectMenu": {
      color: "#000 !important",
    },
    "& span > div": {
      width: "20px",
      height: "20px",
      borderRadius: "50%",
      margin: "5px 10px 5px 0px",
      display: "inline-block",
      verticalAlign: "middle",
    },

  },
  edit_border_color: {
    "& label": {
      color: "yellow",
    },
  },
  buttonGroup:{
   alignItems:"center",
   "& button":{    
    margin: "5px 0px 5px 0px !important",
    borderRadius: "3px !important",
   }
  },
  append_text_color: {
    color: "#ffa500",
    fontSize: "16px",
  },
  appbarHideLabel: {
    color: "yellow",
    fontSize: "8px",
    fontWeight: "lighter",
    padding: "0px 4px",
    position: "absolute",
    bottom: "0",
    left: "0",
  },
  resetButton: {
    minWidth: "inherit",
    padding: "5px",
    background: "#0c853e",
    margin: "0 15px",
    position: "absolute",
    right: "0",
    top: "50%",
    width: "25px",
    height: "25px",
    transform: "translateY(-50%)",
  },

  bulkLabelTop: {
    color: "#fff ",
    fontSize: "8px",
    padding: "5px 4px 0px 12px",
    display: "block",
    position: "absolute",
    overflow: "hidden",
    height: "1px",
    width: "1px",
    clip: "rect(1px, 1px, 1px, 1px)",
  },

  bulkLabelRight: {
    color: "#fff ",
    fontSize: "8px",
    padding: "5px 4px 0px 12px",
    display: "block",
    position: "absolute",
    overflow: "hidden",
    height: "1px",
    width: "1px",
    clip: "rect(1px, 1px, 1px, 1px)",
  },

  refreshButton: {
    minWidth: "inherit",
    padding: "5px",
    background: "#0c853e",
    margin: "0 15px",
    "& svg": {
      fontSize: "10px",
    },
  },
  appbarSelect: {
    borderRadius: "4px !important",
    padding: " 0",
    fontSize: "1em",
    background: "#5d5d5d",
    verticalAlign: "top",
    width: "100%",
    margin: "0",
    "& input": {
      borderRadius: "5px !important",
      padding: "8.5px 14px 8.5px 31px",
      fontSize: "1em",
    },
    "& div": {
      padding: "6px 10px",
      borderRadius: "5px !important",
      fontSize: "0.75em",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
      borderWidth: "1px!important",
    },
    "&.Mui-focused": {
      background: "#868686",
    },
    "&:hover": {
      background: "#868686",
    },
  },
  usersHeader: {
    display: "flex",
    background: "#292929",
    alignItems: "center",
  },
  usersProfileImage: {
    margin: "0 10px",
  },
  globalCreateBody: {
    background: "#000",
    // height: "100vh",
  },
  countofTracks: {
    color: "#AAAAAA",
    display: "block",
    fontSize: "13px",
    "& p": {
      margin: "0",
      padding: "0",
    },
  },
  tableFilterInput: {
    width: "100%",
    "& input": {
      borderRadius: "4px !important",
      padding: "8.5px 27px 8.5px 8.5px",
      fontSize: "0.8em",
      width: "100%",
      background: "#303030",
    },
    "& div": {
      borderRadius: "4px !important",
      width: "100%",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
      margin:"0",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
      borderWidth: "1px !important",
    },
    "& .MuiOutlinedInput-multiline ": {
      padding: "10px",
    },
    "& label": {
      fontSize: "12px",
      top: " -10px !important",
      left: "20px",
    },
    "& .MuiInputLabel-shrink": {
      top: "2px !important",
      left: "0px",
    },
    "& .Mui-focused": {
      color: "#fff !important",
    },
  },
  globalInput: {
    width: "100%",
    padding: "0",
    "& input": {
      borderRadius: "5px !important",
      padding: "10px",
      fontSize: "0.8em",
      background: "none",
    },
    "& div": {
      borderRadius: "5px",
      width: "-webkit-fill-available !important",
      width: "100%!important",
    },

    "& div.MuiAutocomplete-endAdornment": {
      width: "auto !important",
    },
    "& div.MuiCircularProgress-indeterminate": {
      width: "20px !important",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
    "&  .MuiAutocomplete-inputRoot": {
      padding: " 2px 9px",
    },
  },
  userProfileImage: {
    padding: "20px",
    maxWidth: "100px",
    minHeight: "100px",
    borderRadius: " 50% !important",
    marginBottom: "20px",
    margin: " 0 auto",
    background: "none",
    color: "#b9b9b9",
    border: "2px solid #757575",
    "& img": {
      borderRadius: " 90%",
    },
  },
  addedUsersName: {
    maxWidth: "250px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  userNotes: {
    background: "#000",
    borderRadius: "3px",
    width: "97%",
    border: "1px solid #3b3b3b",
    color: "#fff",
    padding: "10px",
    "&:focus": {
      border: "1px solid #46af22",
      outline: "none",
    },
  },
  userName: {
    textAlign: "center",
    display: "block",
  },
  userTabsAll: {
    color: "#fff",
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: "#fff",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#279F04",
    },
  },
  usersButtonsList: {
    textAlign: "right",
    padding: "0 25px",
  },
  globalBlock: {
    marginBottom: "10px",
    "& > div": {
      padding: "5px 30px",
    },
    "& button.MuiButton-text": {
      margin: "15px 0",
    },
  },

  toolsInnerWrap: {
    background: "#636363",
    borderRadius: "5px",
    marginRight: "5px",
    float: "left",
    padding: "3px 5px",
    minWidth: "230px",
    fontSize: "0.8em",
    marginLeft: "6px",
    "& div:before": {
      outline: "none",
      border: "none !important",
      width: "100%",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "2px solid #0C853E",
    },
    "& div": {
      width: "100%",
    },
    "& input": {
      width: "100%",
      padding: "5px 8px",
      fontSize: "0.8em",
      fontWeight: "300",
    },
  },
  emptyImage: {
    border: " 1px solid #3b3b3b",
    borderRadius: "3px",
    maxWidth:"146px",
    padding: "10px",
    textAlign: "center",
    fontSize: "50px",
    minHeight: "176px",
    display: "block",
    lineHeight: "169px",
    color: "#e6e6e6",
  },
  tableMainView: {
    width: "100%",
    height: "calc(100% - 60px)",
    overflow: "auto",
    position: "absolute",
    background: "#000",
    marginTop: "53px",
    "& .MuiAvatar-root": {
      width: "22px",
      height: "22px",
      fontSize: "0.8em",
      background: "#d8d8d5",
      borderRadius: "3px",
    },
  },
  appbarHeaderWrap: {
    background: "#24415f",
  },
  playlistSearchBar: {
    float: "left",
    padding: "3px 5px",
    fontSize: "0.8em",
    marginLeft: "10px",
    width: "-webkit-fill-available",
    width: "100%",
    background: "#475e75",
    marginRight: "5px",
    maxWidth: "300px",
    borderRadius: "5px",
    "& div:before": {
      outline: "none",
      border: "none !important",
      width: "100%",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid #009c40",
    },
    "& div": {
      width: "100%",
    },
    "& input": {
      width: "100%",
      padding: "5px 8px",
      fontSize: "0.8em",
      fontWeight: "300",
    },
  },
});
